<button type="button" [ngClass]="combinedClasses" (click)="handleClick($event)">
  <ng-content></ng-content>
</button>